module.exports = __webpack_public_path__ + "img/image_fundus.cf3f0d4d.jpeg";